/**
 * Layvo material journey — sticky scrollytelling
 * Scrubs --p (0–1), --chapter, --local from scroll position.
 * CSS does the heavy visual lifting; this keeps progress precise cross-browser.
 */
(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-layvo-journey]');
  if (!roots.length) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
  }

  function init(root) {
    var stage = root.querySelector('[data-journey-stage]');
    var chapters = Array.prototype.slice.call(root.querySelectorAll('[data-chapter]'));
    var labelEl = root.querySelector('[data-journey-label]');
    var stepEl = root.querySelector('[data-journey-step]');
    var ticks = Array.prototype.slice.call(root.querySelectorAll('[data-journey-tick]'));
    var count = chapters.length || 1;
    var labels = chapters.map(function (c) {
      return c.getAttribute('data-label') || '';
    });
    var raf = 0;
    var lastChapter = -1;

    if (reduceMotion) {
      root.classList.add('is-reduced');
      root.style.setProperty('--p', '1');
      root.style.setProperty('--chapter', String(count - 1));
      root.style.setProperty('--local', '1');
      return;
    }

    function apply(p) {
      var scaled = p * count;
      var chapter = clamp(Math.floor(scaled), 0, count - 1);
      var local = clamp(scaled - chapter, 0, 1);
      // Ease last chapter to hold at end
      if (chapter === count - 1) local = clamp((scaled - chapter) / 0.85, 0, 1);

      root.style.setProperty('--p', p.toFixed(4));
      root.style.setProperty('--chapter', String(chapter));
      root.style.setProperty('--local', local.toFixed(4));
      root.setAttribute('data-active-chapter', String(chapter));

      if (chapter !== lastChapter) {
        lastChapter = chapter;
        if (labelEl) labelEl.textContent = labels[chapter] || '';
        if (stepEl) {
          stepEl.textContent =
            String(chapter + 1).padStart(2, '0') + ' / ' + String(count).padStart(2, '0');
        }
        ticks.forEach(function (tick, i) {
          tick.classList.toggle('is-active', i === chapter);
          tick.classList.toggle('is-done', i < chapter);
        });
        chapters.forEach(function (ch, i) {
          ch.classList.toggle('is-active', i === chapter);
        });
      }
    }

    function measure() {
      if (!stage) return;
      var rect = root.getBoundingClientRect();
      var total = Math.max(1, root.offsetHeight - window.innerHeight);
      var scrolled = clamp(-rect.top / total, 0, 1);
      apply(scrolled);
    }

    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        measure();
      });
    }

    // Tick navigation
    ticks.forEach(function (tick, i) {
      tick.addEventListener('click', function () {
        var top = root.getBoundingClientRect().top + window.scrollY;
        var total = Math.max(1, root.offsetHeight - window.innerHeight);
        var target = top + ((i + 0.15) / count) * total;
        window.scrollTo({ top: target, behavior: 'smooth' });
      });
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    measure();
  }

  roots.forEach(init);
})();
